import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { cssClass } from '~src/style';

const cssPrefix = 'SelectModelsDialog';
export namespace SelectModelsDialogStyles {

  export const dropdownStyle = cssClass(cssPrefix, 'dropdown-style', {
    width: '100%'
  });

  export const labelWithTooltipContainer = cssClass(cssPrefix, 'label-with-tooltip-container', {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  });

  export const descriptionText = cssClass(cssPrefix, 'description-text', {
    display: 'inline'
  });

  export const descriptionContainer = cssClass(cssPrefix, 'description-container', {
    marginBottom: TabStyles.Spacing.MediumSpace
  });

  export const dropdownListStyle = cssClass(cssPrefix, 'dropdown-list-style', {
    maxHeight: '250px',
    overflowY: 'auto'
  });

  export const formTable = cssClass(cssPrefix, 'form-table', {
    width: '100%'
  });

  export const customLLMformTable = cssClass(cssPrefix, 'form-table', {
    width: '100%',
    paddingLeft: '20px'
  });

  export const warningMessage = cssClass(cssPrefix, 'warning-message', {
    color: DesignTokens.color.feedback.default.warning_dark
  });

  export const warningMessageContainer = cssClass(cssPrefix, 'warning-message-container', {
    display: 'inline-flex',
    alignItems: 'flex-start',
    gap: '4px',
    color: DesignTokens.color.feedback.default.warning_dark
  });

  export const warningIcon = cssClass(cssPrefix, 'warning-icon', {
    paddingTop: '2px'
  });

}
